import { PiniaColada } from "@pinia/colada";
import { createPinia } from "pinia";

import type { VueIslandConfig } from "@solvari/common-fe/helpers";

import {
  emitComponentLoaded,
  initEmitIframeResize,
  initOnArgusSession,
  initVueIslands,
} from "@solvari/common-fe/helpers";
import { initFontAwesome } from "@solvari/common-fe/integrations";
import { initPrimeVue } from "@solvari/components";

import "@/app/plugins/sentry";

import "@/app/styles/tailwind.css";

function main() {
  initEmitIframeResize();
  initOnArgusSession();
  emitComponentLoaded("document");
  initFontAwesome();

  const components = {
    leadForm: () => import("@/features/forms-iframe/leadForm.ts"),
  } satisfies VueIslandConfig;

  const pinia = createPinia();
  initVueIslands(components, (app) => {
    app.use(pinia);
    app.use(PiniaColada, {});
    initPrimeVue(app);
  });
}

main();
